import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { h2, headingStyles } from '@helpers/typography';
import Button from '@stories/Components/Buttons/Button/Button';
import styled from 'styled-components';
import LocationTabButtonStyles from '@stories/Components/Buttons/LocationTabButton/LocationTabButton.styles';
const Bg = styled.div `
  background-color: ${brand.grey};
  height: 100%;
`;
const Container = styled.div `
  color: ${brand.black};
  ${siteWide};
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;

  @media ${from(Device.TabletLarge)} {
    padding-top: 70px;
  }
`;
const Title = styled.h1 `
  ${h2};
  font-size: 58px;
  line-height: 1;
  margin-bottom: 60px;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const SecondaryGrid = styled.div `
  display: grid;
  row-gap: 20px;
  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;
  }
`;
const Form = styled.form `
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: min-content min-content min-content 1fr;
  grid-template-areas:
    'location location location location'
    'bedroom bedroom bedroom bedroom'
    'availability availability availability availability'
    'pcm pcm pcm pcm'
    'clear submit submit submit';

  gap: 20px;

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: min-content min-content 1fr;
    grid-template-areas:
      'location location location'
      'bedroom availability pcm'
      'clear .  submit';
    gap: 50px;
  }
`;
const FormLocation = styled.div `
  grid-area: location;

  @media ${from(Device.TabletLarge)} {
    ${LocationTabButtonStyles.ContentContainer} {
       align-items: flex-start;
    }
  }
`;
const FormBedroom = styled.div `
  grid-area: bedroom;
`;
const FormAvailability = styled.div `
  grid-area: availability;
`;
const FormPCM = styled.div `
  grid-area: pcm;
  margin-bottom:calc(60px);
`;
const FormLabel = styled.h2 `
  ${headingStyles}
  font-size: 20px;
`;
const SubmitButton = styled(Button) `
  width: 100%;
  grid-area: submit;
  margin-bottom: 20px;
  align-self: flex-end;

  @media ${from(Device.TabletLarge)} {
    margin-bottom: 75px;
  }

  span {
    margin-inline: auto;
  }
`;
const ClearAllButton = styled.button `
  ${ButtonReset}
  ${fonts.altGothicNo2.regular};
  color: ${brand.black};
  font-size: 18px;
  display: block;
  text-transform: uppercase;
  white-space: nowrap;
  text-decoration: underline;
  text-decoration-color: ${brand.yellow};
  text-decoration-thickness: 4px;
  text-underline-position: under;
  grid-area: clear;
  justify-self: flex-start;
  margin-bottom: 30px;
  align-self: flex-end;

  @media ${from(Device.TabletLarge)} {
    margin-bottom: 85px;
  }
`;
const SearchStyles = {
    Container,
    Bg,
    Title,
    SecondaryGrid,
    FormLabel,
    Form,
    SubmitButton,
    ClearAllButton,
    FormLocation,
    FormBedroom,
    FormAvailability,
    FormPCM,
};
export default SearchStyles;
